import React, {useEffect, useState} from 'react';
import logo from "../../../assets/images_custom/logo-form-extension.png";
import InputComponent from "../../../components/InputComponent";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlined';
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {validateEmail} from '../../../services/ValidationSvc'
import RequestSvc from '../../../services/RequestSvc';
import {URL_DASHBOARD, URL_LOGIN} from '../../../utils/Constants';
import {useLocalStorage} from "../../../services/UseLocalStorageSvc";
import LinearProgress from '@mui/material/LinearProgress';

// DEFINIR LA URL DE LA API (Asegúrate de que coincida con tu backend)
// NOTA: Usa '/hooks' para producción o '/hookstest' si sigues probando el endpoint nuevo
const API_BASE_URL = "https://pulpoia-ops.com/backend/nodeapi/"; 
//const MIGRATION_ENDPOINT = `${API_BASE_URL}/hookstest/create-migration-session`; 
const MIGRATION_ENDPOINT = `${API_BASE_URL}/hooks/create-migration-session`; 

export default function LoginForm({ onForgotClick }) {

    let [email, setEmail] = useState("");
    let [password, setPassword] = useState("");
    let [isChecked, setIsChecked] = useState(false);
    let [errorLogin, setErrorLogin] = useState(false);
    let [errorMessage, setErrorMessage] = useState();
    let [localStorageValue, setLocalStoreValue] = useLocalStorage('P-CS', '');
    let [loading, setLoading] = useState(false);

    // --- NUEVOS ESTADOS PARA LA MIGRACIÓN ---
    const [showMigrationWall, setShowMigrationWall] = useState(false);
    const [migrationUser, setMigrationUser] = useState(null);

    useEffect(() => {
        if (localStorage.checkbox && localStorage.email !== "") {
            setEmail(localStorage.email)
            setIsChecked(true)
        }
    }, []);

    /*  INIT - EVENTS */

    const onClickForgotPasswordBtn = () => {
        if (onForgotClick) return onForgotClick();
        alert("Implement password recovery");
    }

    const onClickUnlockAccessBtn = () => {
        alert("Implement create account")
    }

    const onChangeRememberMe = (event) => {
        setIsChecked(event.target.checked)
    }

    const submit = (event) => {
        if (isChecked && email !== "") {
            localStorage.setItem("email", email)
            localStorage.setItem("checkbox", isChecked)
        } else {
            localStorage.removeItem("email")
            localStorage.removeItem("checkbox")
        }
        let isValidForm = validateBeforeSubmit();
        if (isValidForm) {
            setLoading(true); // Show progress bar
            tryLogin()
        }
    }

    /**
     * Validar si el formulario es valido o no.
     * @returns {boolean}
     */
    const validateBeforeSubmit = () => {
        return !(email === "" || password === "");
    }
    /**
     * Hacer el submit para loguearse
     * @returns {Promise<void>}
     */
    const tryLogin = async () => {
        let svc = new RequestSvc();
        // Agregar los header para el request.
        let headers = new Headers();
        headers.append('Authorization', 'Basic ' + btoa(`${email}:${password}`));
        headers.append('src', 'WebPageLoginForm');
        headers.append('referer', 'https://app.pulpoia.com/login');
        
        // Hacemos la petición
        let result = await svc.get(URL_LOGIN, headers);
        setLoading(false); // Hide progress bar when response is received
        console.log("Login result: ", result);

        // 1. CASO ERROR (Credenciales inválidas o error de servidor)
        if (result.error && !result.data?.migration_needed) { // Aseguramos que no sea un error falso por migración
             setErrorLogin(result.error)
             setErrorMessage(result.data.message)
             return;
         }

        // 2. CASO INTERCEPCIÓN: MIGRACIÓN REQUERIDA (NUEVO)
        // Verificamos la bandera que configuramos en el Backend (AuthSvcPulpo.js)
        if (result.data && result.data.migration_needed) {
            console.log("Usuario requiere migración. Deteniendo login standard.");
            setMigrationUser(result.data.customerInfo); // Guardamos info del usuario
            setShowMigrationWall(true); // Cambiamos la vista
            return; // DETENEMOS LA REDIRECCIÓN
        }

        // 3. CASO ÉXITO NORMAL (Usuario ya en Stripe o sin deuda)
         await setLocalStoreValue(result.data.token)
        // window.location.href = URL_DASHBOARD + result.data.token
        window.location.href = URL_DASHBOARD
    }

    /**
     * LÓGICA PARA PROCESAR LA MIGRACIÓN (BOTÓN VERDE)
     */
    const handleProcessMigration = async () => {
        if(!migrationUser || !migrationUser.Email) return;

        setLoading(true);
        try {
            // Usamos fetch directo para evitar conflictos con interceptores del RequestSvc
            const response = await fetch(MIGRATION_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: migrationUser.Email 
                    // El backend busca el resto de datos por seguridad
                })
            });

            const data = await response.json();

            if (data.url) {
                // Redirigir a Stripe
                window.location.href = data.url;
            } else {
                setLoading(false);
                setErrorLogin(true);
                setErrorMessage(data.error || "Error al generar el enlace de pago.");
            }
        } catch (e) {
            setLoading(false);
            setErrorLogin(true);
            setErrorMessage("Error de conexión al intentar migrar.");
        }
    }

    // --- RENDERIZADO CONDICIONAL ---

    // VISTA A: EL MURO DE MIGRACIÓN
    if (showMigrationWall) {
        return (
            <div className={"login-form-layout"} style={{textAlign: 'center'}}>
                 {loading && <LinearProgress style={{marginBottom: 16}} />}
                 <img src={logo} alt={"imgBackground"} className={"login-container-img-logo"}/>
                 
                 <div style={{
                     backgroundColor: '#fff3cd', 
                     color: '#856404', 
                     padding: '20px', 
                     borderRadius: '8px', 
                     border: '1px solid #ffeeba',
                     marginBottom: '20px'
                 }}>
                     <h3 style={{marginTop:0}}>⚠️ Actualización Requerida</h3>
                     <p>Hola <strong>{migrationUser?.Nombre}</strong>,</p>
                     <p style={{fontSize: '14px'}}>
                         Hemos actualizado nuestra plataforma de pagos para mayor seguridad. 
                         Tu suscripción requiere una reactivación rápida.
                     </p>
                     <p style={{fontSize: '14px', fontWeight: 'bold'}}>
                         Hemos conservado tus días restantes. No se te cobrará nada hoy.
                     </p>
                            <p style={{fontSize: '14px'}}>
                                Si tienes alguna pregunta, hazla por telegram aquí:
                                <a href='https://t.me/soporte_pulpoia' style={{color: '#000'}}>
                                     https://t.me/soporte_pulpoia
                                </a>
                        

                       <br/>
                       o desde la app de telegram de tu telefono busca @soporte_pulpoia
                     </p>
                 </div>

                 <button 
                    className={"login-button"} 
                    onClick={handleProcessMigration}
                    style={{backgroundColor: '#28a745'}} // Verde para indicar acción positiva
                 >
                    Reactivar Suscripción Ahora
                 </button>

                 {errorLogin && (
                    <p className='login-form-error-message' style={{marginTop:'10px'}}>
                        {errorMessage}
                    </p>
                 )}
            </div>
        )
    }

    // VISTA B: LOGIN NORMAL (Tu código original con pequeños ajustes)
    return (<div className={"login-form-layout"}>
        {loading && <LinearProgress style={{marginBottom: 16}} />}
        
    <img src={logo} alt={"imgBackground"} className={"login-container-img-logo"}/>
        <InputComponent
            placeholder={"Correo electrónico"}
            className={"login-input"}
            value={email}
            
            type={"email"}
            onChange={(text) => setEmail(text)}
            validateMethod={validateEmail}
            error={setErrorLogin}
        />
        <InputComponent
            placeholder={"Contraseña"}
            className={"login-input"}
           
            rightIcon={<VisibilityOutlinedIcon/>}
            type={"password"}
            onChange={(text) => setPassword(text)}
            error={setErrorLogin}
        />
        <button className={"login-button-type-label-forgot-password"} onClick={onClickForgotPasswordBtn}>
            ¿Olvidaste tu contraseña?
        </button>
        {
        errorLogin && (
            typeof errorMessage === 'string' && errorMessage.includes("<a ")
                ? <span className='login-form-error-message' dangerouslySetInnerHTML={{ __html: errorMessage }} />
                : <span className='login-form-error-message'>{errorMessage}</span>
             )
        }

        <div className={"login-container-remember-me"}>
            <input style={{float: "left"}}
                   type={"checkbox"}
                   name={"rememberMe"}
                   id={"rememberMe"}
                   checked={isChecked}
                   onChange={onChangeRememberMe}/>
            <label className={"login-label-remember-me"}>Acuérdate de mí</label>
        </div>
    <button className={"login-button"}
        onClick={submit}>Iniciar sesión
        </button>
        <span
            className={"login-button-type-label-unlock-access"}
            >¿No tienes cuenta?.<br/> <a href='https://pulpoia.com'> Desbloquea tu acceso ahora</a>
        </span>
        
        <a 
            href="https://t.me/soporte_pulpoia" 
            target="_blank" 
            rel="noopener noreferrer"
            className={"login-button-telegram-support"}
        >
            <span className="telegram-icon">📞</span>
            Contactar soporte por Telegram de Lunes a Viernes 9am-5pm
        </a>
        
    </div>);
}